// 站内聚合数据源（静态展示用）
export interface HotItem {
  rank: number;
  title: string;
  summary: string;
  tag: string;
  trend: string;
  meta: string;
  hot: "raise" | "steady" | "new";
}

export const hotBoard: HotItem[] = [
  {
    rank: 1,
    title: "剧组「开机即杀青」风波发酵，导演深夜发文回应",
    summary: "网传该剧组拍摄两天即停摆，主创团队被曝集体离组，相关聊天记录陆续流出，后续进展仍在整理中。",
    tag: "娱乐圈",
    trend: "热度持续攀升",
    meta: "12.6万 看过 · 26 条线索",
    hot: "raise",
  },
  {
    rank: 2,
    title: "选秀出道组番位争议，粉丝后援会连发声明",
    summary: "官方名单公布后队内顺序引发讨论，多家站子同步放出应援数据对比，事件已被多个账号转评跟进。",
    tag: "选秀",
    trend: "讨论扩散中",
    meta: "9.8万 看过 · 18 条线索",
    hot: "raise",
  },
  {
    rank: 3,
    title: "综艺「临时换人」疑云，制片方口径前后不一",
    summary: "从官宣到临录制前名单变动，节目组两版回应被网友逐句比对，目前停留在猜测阶段。",
    tag: "综艺",
    trend: "需继续观望",
    meta: "7.4万 看过 · 12 条线索",
    hot: "steady",
  },
  {
    rank: 4,
    title: "新剧男主戏份被砍疑云，片方晒出原始合同",
    summary: "围绕戏份分配的新瓜刚刚浮出水面，片方晒合同自证后讨论方向出现反转，线索正在整理。",
    tag: "剧组",
    trend: "最新出现",
    meta: "5.1万 看过 · 8 条线索",
    hot: "new",
  },
];

export interface FeedItem {
  time: string;
  title: string;
  summary: string;
  tag: string;
  label: "新瓜" | "进展" | "求证" | "补料";
  count: string;
}

export const feedList: FeedItem[] = [
  {
    time: "今天 21:40",
    title: "品牌直播专场主持人临时被换，替补身份成谜",
    summary: "开场前 40 分钟换人引发弹幕讨论，替补主持个人主页被考古，是否与上一场冲突有关暂未证实。",
    tag: "商务",
    label: "新瓜",
    count: "评论 300+",
  },
  {
    time: "今天 19:12",
    title: "恋综「心动短信」现重名乌龙，官方后台截图流出",
    summary: "嘉宾收发记录与播出版本对不上，节目组称是剪辑导致的误会，网络仍存多种解读。",
    tag: "恋综",
    label: "进展",
    count: "评论 200+",
  },
  {
    time: "今天 16:05",
    title: "歌手巡演加场名单流出，与年初采访说法相悖",
    summary: "此前公开表示暂不加场的艺人，如今被拍到彩排现场布景，回应口径仍在变化。",
    tag: "音乐",
    label: "求证",
    count: "评论 150+",
  },
  {
    time: "今天 13:48",
    title: "老牌剧组翻红，当年「换角内幕」被考古重提",
    summary: "旧帖被顶上来后热度回升，多位当事人当年发言被重新截取对比，属于经典瓜的二次传播。",
    tag: "考古",
    label: "补料",
    count: "评论 90+",
  },
  {
    time: "今天 10:32",
    title: "时尚周座位排序图流出，咖位暗战再起",
    summary: "主办方座次表被晒出，官方暂未回应，多位造型博主据此展开新一轮解读盘点。",
    tag: "时尚",
    label: "新瓜",
    count: "评论 60+",
  },
];

export interface TrackStep {
  date: string;
  status: "done" | "ing" | "wait";
  desc: string;
}

export interface TrackItem {
  name: string;
  brief: string;
  steps: TrackStep[];
  latest: string;
}

export const trackList: TrackItem[] = [
  {
    name: "换角争议事件",
    brief: "从阵容公布到二次官宣，全程脉络已整理成时间线。",
    latest: "片方二度回应，口径较首次出现明显变化",
    steps: [
      { date: "周一", status: "done", desc: "阵容名单首曝，网友发现核心主演缺席" },
      { date: "周三", status: "done", desc: "制片人发长文，被质疑避重就轻" },
      { date: "周五", status: "ing", desc: "二轮声明发布，对比版本差异中" },
      { date: "下周", status: "wait", desc: "待补充后续艺人方回应" },
    ],
  },
  {
    name: "番位争议事件",
    brief: "名单公布后队内排序引发的粉丝多方混战。",
    latest: "多家后援会同步停止打卡，静待官方说法",
    steps: [
      { date: "上周日", status: "done", desc: "出道名单公布，顺序引发第一轮争议" },
      { date: "本周一", status: "done", desc: "后援会发联合声明要求复核" },
      { date: "本周二", status: "ing", desc: "应援数据对比图持续扩散" },
      { date: "待定", status: "wait", desc: "等待经纪公司正式公告" },
    ],
  },
  {
    name: "直播换人事件",
    brief: "带货专场临开场换主持人，身份成谜。",
    latest: "替补主持资料被逐条考古中",
    steps: [
      { date: "本周三", status: "done", desc: "品牌方公布专场阵容预告" },
      { date: "今天", status: "ing", desc: "开场前换人，替补身份被挖" },
      { date: "待定", status: "wait", desc: "等待本人或品牌方回应" },
    ],
  },
];

export interface TopicRail {
  name: string;
  num: string;
}

export const topicRail: TopicRail[] = [
  { name: "娱乐圈", num: "146 条" },
  { name: "综艺现场", num: "88 条" },
  { name: "剧组动态", num: "102 条" },
  { name: "选秀出道", num: "64 条" },
  { name: "商务代言", num: "71 条" },
  { name: "考古回放", num: "95 条" },
];

export interface TopRank {
  rank: number;
  title: string;
  delta: number;
}

export const topList: TopRank[] = [
  { rank: 1, title: "选秀出道组番位争议，后援会连发声明", delta: 2 },
  { rank: 2, title: "剧组「开机即杀青」，导演深夜回应", delta: 0 },
  { rank: 3, title: "综艺临时换人，制片方口径前后不一", delta: -1 },
  { rank: 4, title: "新剧男主戏份被砍疑云，片方晒合同", delta: 5 },
  { rank: 5, title: "恋综心动短信现重名乌龙", delta: 1 },
  { rank: 6, title: "歌手巡演加场名单流出", delta: -3 },
  { rank: 7, title: "品牌直播专场主持人被换", delta: 4 },
  { rank: 8, title: "时尚周座次暗战，咖位盘点刷屏", delta: -2 },
];

export interface PackItem {
  tag: string;
  title: string;
  count: string;
  desc: string;
  from: string;
}

export const packList: PackItem[] = [
  {
    tag: "打包合集",
    title: "某综艺「换人风波」一条线打包",
    count: "12 条线索",
    desc: "从官宣到两版回应的全部过程按时间排好，一次点开看全，不用去主页逐条翻。",
    from: "线索链完整，共 4 个节点",
  },
  {
    tag: "打包合集",
    title: "某剧组「番位暗战」多站联合盘点",
    count: "9 条线索",
    desc: "把几家后援会声明、应援数据和官方口径收进同一条时间线，方便横向比对。",
    from: "跨平台来源，口径各有侧重",
  },
  {
    tag: "追踪专题",
    title: "年度「考古回放」老瓜新炒合集",
    count: "21 条线索",
    desc: "经典旧帖被顶热后二次传播，均按「原帖 → 转评 → 当事人回应」顺序整理。",
    from: "持续更新，旧瓜新进展会补进来",
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqList: FaqItem[] = [
  {
    q: "这里的内容是不是被改写过？",
    a: "不会改写原意。页面只做「按时间、按事件」的聚合与排序，把同类传闻、聊天截图要点、人物和后续进展放到一起，方便你横向看全，来源口径都保留原说法。",
  },
  {
    q: "为什么同一个事件会分好几个卡片？",
    a: "因为一个事件往往有多条线索（首曝、声明、回应、反转）。这里按「一条线索一个入口」整理，卡片上是短摘要，展开类详情由站内规划，避免把不同时间点混成一段。",
  },
  {
    q: "「求证 / 待证实」代表什么意思？",
    a: "吃瓜内容不少停留在网传阶段。带「求证」标签的，意味着各方尚未给出确定口径，页面只呈现现有说法与疑点，不替你下结论。",
  },
  {
    q: "刷新后能看到新瓜吗？",
    a: "页面按发布时间倒序展示，新增的线索会排到最上方并带「新瓜 / 进展」标，方便多瓜连吃时不遗漏当天变化。",
  },
  {
    q: "需要登录或付费才能看吗？",
    a: "不需要。当前页面为聚合浏览形态，标题、摘要与线索入口均直接可见，方便一次性看全今天的好几个瓜。",
  },
];

export const statsData = [
  { num: "3.8 万+", label: "累计汇总线索" },
  { num: "1.2 万+", label: "完成打包的事件" },
  { num: "600+", label: "持续追踪中" },
];